export const BUYER_ASKED_TO_BUY = 0;
export const BUYER_CANCELLED_OFFER = 1;
export const SELLER_CANCELLED_OFFER = 2;
export const SELLER_CONFIRMED_OFFER = 3;
export const BUYER_CONFIRMED_DELIVERY = 4;
export const REQUESTER_REJECTED_OFFER = 6; // from 0 to 4 only for wish fulfillment offers



